import Switcher from "./utils/Switcher";
import Form from "../../modules/core/forms/theme/js/Form";

export default class Panel {
    public static onAddressForm($uid: JQuery): void {
        new Form($uid);

        (<any>window).Site.discover($uid);

        Switcher.init($('input[name="iscompany"]', $uid), $('._js-forcompany', $uid));
    }

    public static initDocumentsPage(): void {
        const $add = $('.vpaneldocuments__add');
        const $addform = $('.vpaneldocuments__addform');

        $add.on('click', (e) => {
            $add.hide();
            $addform.show();
        });

        $addform.hide();
    }
}
